import icon from '@/assets/dashalignlogo-icon.png';

// BrandedLoader — the app's single loading state: a modern spinning ring with
// the DashAlign mark at its center, instead of the old bare grey ring on white.
// Used for the auth-resolve gate and the route-level Suspense fallback in
// App.tsx (see #822 perf work — most launches should be interactive fast enough
// that this barely flashes, but when it does show it should look like us, not a
// blank screen).
//
// fullScreen (default) centers it in a min-h-screen shell for a whole-page load;
// pass fullScreen={false} to drop it inline inside a smaller container.
export function BrandedLoader({
  label = 'Loading DashAlign…',
  fullScreen = true,
}: {
  label?: string | null;
  fullScreen?: boolean;
}) {
  return (
    <div
      className={
        fullScreen
          ? 'min-h-screen bg-background flex items-center justify-center'
          : 'flex items-center justify-center py-12'
      }
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="relative h-20 w-20">
          {/* Faint full ring as the track… */}
          <span className="absolute inset-0 rounded-full border-[3px] border-primary/15" />
          {/* …and a single-arc ring that spins over it. */}
          <span className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-primary animate-spin" />
          {/* Brand mark, held still in the center. */}
          <img
            src={icon}
            alt=""
            aria-hidden
            className="absolute inset-0 m-auto h-9 w-9 object-contain"
          />
        </div>
        {label ? <p className="text-sm text-muted-foreground">{label}</p> : null}
        <span className="sr-only">Loading</span>
      </div>
    </div>
  );
}
